module.exports = __webpack_public_path__ + "static/media/bethel-godwins-portrait.9b87e4f8.jpg";